module.exports = __webpack_public_path__ + "static/united-kingdom-flag-square-xs@2x-1edfc090485d8d165c5f3b8927fa98fc.png";